import(/* webpackMode: "eager" */ "/vercel/path0/src/app/empresa/page.tsx");
